<template>
  <div class="main-page">
    <Header />
    <div class="main-content">
      <router-view></router-view>
    </div>
    <Footer />
    <!-- <div class="buttons">
      <el-button type="primary" @click="goHome">Home</el-button>
    </div> -->
  </div>
</template>

<script>
import Header from './components/header'
import Footer from './components/footer'

export default {
  components: {
    Header,
    Footer
  },
  name: 'App',
  methods: {
    goHome() {
      try {
        debugger
        console.log('Attempting navigation to home');
        this.$router.push('/');
      } catch (error) {
        console.error('Navigation error:', error);
      }
    }
  }
}
</script>

<style lang="scss">
@media (max-width: 768px) {
  .main-content {
    background: #fff !important;
  }
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.main-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;

  .main-content {
    flex: 1;
    min-height: 0;
    background: #eee;
  }
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  background: #e2e2e2;
}
.buttons {
  margin-top: 20px;
}
</style>
